/**
 * Project NAVIGATOR
 * Main entry point - routes to different pages based on URL path
 */

import './style.css';
import { renderLandingPage } from '@/pages/renderLandingPage';
import { renderHeadlessTilePage } from '@/pages/renderHeadlessTilePage';
import { renderProtoBenchmarkPage } from '@/pages/renderProtoBenchmarkPage';
import { renderSpriteDemo } from '@/pages/renderSpriteDemo';
import { renderAudioDemo } from '@/pages/renderAudioDemo';
import { renderSampleBrowser } from '@/pages/renderSampleBrowser';
import { renderSequenceTest } from '@/pages/renderSequenceTest';
import { renderMapPage } from '@/qud/pages/renderMapPage';

// Routing based on pathname
async function router() {
  const appElement = document.querySelector<HTMLDivElement>('#app');
  if (!appElement) {
    console.error('App element not found');
    return;
  }

  const path = window.location.pathname;

  // Reset viewport mode before rendering (pages can opt-in to full-viewport)
  appElement.classList.remove('full-viewport');

  if (path === '/qud-map' || path === '/demo') {
    await renderMapPage(appElement);
  } else if (path === '/sprite-demo') {
    await renderSpriteDemo(appElement);
  } else if (path === '/audio-demo') {
    await renderAudioDemo(appElement);
  } else if (path === '/sample-browser') {
    await renderSampleBrowser(appElement);
  } else if (path === '/sequence-test') {
    await renderSequenceTest(appElement);
  } else if (path === '/headless-render') {
    await renderHeadlessTilePage(appElement);
  } else if (path === '/proto-benchmark') {
    await renderProtoBenchmarkPage(appElement);
  } else {
    await renderLandingPage(appElement);
  }
}

// Handle browser back/forward navigation
window.addEventListener('popstate', router);

// Handle internal link clicks - intercept to use pushState instead of full navigation
document.addEventListener('click', (e) => {
  const target = e.target as Element;
  const link = target.closest('a[href^="/"]');
  if (link && !link.hasAttribute('data-external')) {
    e.preventDefault();
    const href = link.getAttribute('href')!;
    history.pushState(null, '', href);
    router();
  }
});

// Start the app
router();
